export default __webpack_public_path__ + "static/media/05AW2APR66.20771631.jpg";